import { ImageSelected } from './ImageSelected.js'

window.customElements.define('image-selected', ImageSelected)
